import { render, staticRenderFns } from "./girl.vue?vue&type=template&id=4addda08&scoped=true&"
import script from "./girl.vue?vue&type=script&lang=js&"
export * from "./girl.vue?vue&type=script&lang=js&"
import style0 from "./girl.vue?vue&type=style&index=0&id=4addda08&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addda08",
  null
  
)

export default component.exports